import { render, staticRenderFns } from "./FormBlock.vue?vue&type=template&id=31c545e8"
import script from "./FormBlock.vue?vue&type=script&lang=js"
export * from "./FormBlock.vue?vue&type=script&lang=js"
import style0 from "./FormBlock.vue?vue&type=style&index=0&id=31c545e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports